var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 559,
    viewBox: "0 0 429 559",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7798_23675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.736 429.688C289.048 424.955 289.461 419.215 289.134 417.381L288.815 415.543C288.815 415.543 299.653 417.147 300.317 417.317L300.982 417.487C300.982 417.487 297.478 429.647 297.237 432.119L296.996 434.592C296.996 434.592 290.092 432.629 288.218 432.345L286.344 432.062C286.344 432.062 287.482 430.602 287.736 429.688Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.374 350.513L347.53 343.762L334.74 345.362L337.549 350.833L348.374 350.513Z",
    fill: "url(#paint0_linear_7798_23675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.316 373.688C190.649 374.889 189.184 375.797 188.197 376.271C187.208 376.751 186.663 376.611 186.663 376.611C186.663 376.611 188.456 378.075 188.952 381.223C189.448 384.37 188.645 385.808 188.645 385.808C188.645 385.808 191.378 381.894 191.874 378.842C192.365 375.789 191.316 373.688 191.316 373.688Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.148 363.13L283.324 359.01L279.973 358.842L280.547 364.948L283.148 363.13Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.315 386.591L227.712 379.557C227.712 379.557 222.703 379.179 220.803 377.391C218.909 375.605 218.205 372.998 218.205 372.998L213.631 378.45C213.631 378.45 217.32 385.644 223.315 386.591Z",
    fill: "#87C6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.099 420.806C189.099 420.806 189.124 417.103 190.39 415.885C191.656 414.667 192.967 414.408 192.967 414.408L183.638 409.303C183.638 409.303 181.653 410.71 180.615 412.372C179.577 414.034 180.257 415.352 180.257 415.352L189.097 420.812L189.099 420.806Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.101 404.625C240.101 404.625 243.661 404.986 246.233 402.219L248.805 399.453L251.571 404.401C251.571 404.401 250.134 407.743 247.137 409.036C244.14 410.323 241.603 410.211 241.603 410.211L240.102 404.619L240.101 404.625Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.037 431.072C238.037 431.072 237.307 424.737 237.86 424.158C238.412 423.579 231.51 424.82 229.338 424.17L227.166 423.519C227.166 423.519 227.691 429.05 228.773 429.959C229.854 430.868 238.035 431.078 238.035 431.078L238.037 431.072Z",
    fill: "url(#paint1_linear_7798_23675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.083 341.217C290.083 341.217 294.095 343.318 294.624 343.106C295.152 342.893 292.566 347.072 292.446 348.653L292.326 350.234C292.326 350.234 288.794 348.477 288.465 347.54C288.136 346.602 290.083 341.217 290.083 341.217Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.322 383.616L336.075 379.654L341.674 382.793C341.674 382.793 339.961 384.2 339.576 385.707L339.192 387.207L333.994 384.898L334.32 383.622L334.322 383.616Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.076 458.995L335.518 452.453L341.182 453.903L338.895 459.454L335.076 458.995Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.442 395.627C276.442 395.627 283.192 388.463 284.526 379.274C285.86 370.086 284.828 369.006 284.828 369.006C284.828 369.006 283.302 369.166 281.441 369.523C279.58 369.881 277.664 369.442 277.664 369.442C277.664 369.442 277.767 375.288 275.641 381.298C273.517 387.301 271.568 389.709 271.568 389.709L276.442 395.627Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.835 421.196L319.17 422.439C319.17 422.439 320.558 423.66 320.262 425.138L319.965 426.617L328.624 424.984C328.624 424.984 328.142 422.226 328.831 421.189L328.835 421.196Z",
    fill: "url(#paint2_linear_7798_23675)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7798_23675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.839 391.186C116.864 395.683 115.635 401.305 115.697 403.167L115.751 405.032C115.751 405.032 105.253 401.896 104.619 401.633L103.986 401.37C103.986 401.37 109.19 389.836 109.782 387.423L110.373 385.01C110.373 385.01 116.927 387.939 118.741 388.487L120.555 389.035C120.555 389.035 119.22 390.317 118.839 391.186Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5161 460.9L47.388 467.702L60.2747 467.946L58.276 462.13L47.5161 460.9Z",
    fill: "url(#paint3_linear_7798_23675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.273 460.384C207.105 459.291 208.684 458.602 209.729 458.273C210.776 457.939 211.296 458.155 211.296 458.155C211.296 458.155 209.73 456.451 209.689 453.264C209.647 450.078 210.648 448.77 210.648 448.77C210.648 448.77 207.384 452.254 206.457 455.203C205.535 458.155 206.273 460.384 206.273 460.384Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.875 457.717L113.112 461.77L116.405 462.415L116.709 456.29L113.875 457.717Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.446 443.041L171.09 449.375C171.09 449.375 175.994 450.464 177.619 452.505C179.238 454.544 179.562 457.225 179.562 457.225L184.868 452.481C184.868 452.481 182.245 444.834 176.446 443.041Z",
    fill: "#87C6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.197 414.071C215.197 414.071 214.644 417.733 213.217 418.758C211.79 419.782 210.455 419.851 210.455 419.851L218.96 426.236C218.96 426.236 221.125 425.127 222.39 423.63C223.655 422.134 223.17 420.732 223.17 420.732L215.2 414.066L215.197 414.071Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.407 422.802C162.407 422.802 158.935 421.936 155.994 424.307L153.053 426.678L151.022 421.386C151.022 421.386 152.921 418.283 156.073 417.431C159.222 416.585 161.717 417.059 161.717 417.059L162.405 422.807L162.407 422.802Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.226 396.909C168.226 396.909 168.044 403.284 167.414 403.778C166.784 404.272 173.794 404.029 175.85 404.983L177.907 405.937C177.907 405.937 178.178 400.388 177.237 399.334C176.295 398.28 168.229 396.904 168.229 396.904L168.226 396.909Z",
    fill: "url(#paint4_linear_7798_23675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.882 478.414C103.882 478.414 100.211 475.761 99.6578 475.896C99.1046 476.031 102.261 472.264 102.606 470.717L102.95 469.169C102.95 469.169 106.195 471.412 106.387 472.387C106.578 473.362 103.882 478.414 103.882 478.414Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.151 430.14L63.8498 433.811L58.757 429.905C58.757 429.905 60.6528 428.757 61.2496 427.321L61.8439 425.89L66.6585 428.919L66.1534 430.134L66.151 430.14Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1687 355.425L74.7974 361.836L69.3982 359.592L72.4539 354.425L76.1687 355.425Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.152 426.507C125.152 426.507 117.449 432.634 114.816 441.538C112.184 450.441 113.051 451.657 113.051 451.657C113.051 451.657 114.584 451.717 116.477 451.629C118.37 451.54 120.204 452.249 120.204 452.249C120.204 452.249 120.937 446.448 123.899 440.804C126.859 435.165 129.132 433.06 129.132 433.06L125.152 426.507Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9498 393.723L86.6928 393.873C86.6928 393.873 85.4939 392.467 85.9983 391.045L86.5027 389.624L77.6997 390.004C77.6997 390.004 77.7829 392.803 76.9531 393.731L76.9498 393.723Z",
    fill: "url(#paint5_linear_7798_23675)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7798_23675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.55 282.988C270.227 280.743 275.081 277.083 276.313 275.548L277.553 274.016C277.553 274.016 283.81 283.753 284.136 284.4L284.463 285.047C284.463 285.047 272.354 290.711 270.22 292.237L268.085 293.764C268.085 293.764 264.848 286.907 263.771 285.219L262.695 283.532C262.695 283.532 264.647 283.423 265.55 282.988Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.686 276.197L375.469 270.834L365.308 261.771L362.908 267.808L370.686 276.197Z",
    fill: "url(#paint6_linear_7798_23675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.09 167.357C241.671 167.66 239.931 167.126 238.867 166.671C237.798 166.218 237.53 165.687 237.53 165.687C237.53 165.687 237.612 168.13 235.453 170.713C233.293 173.296 231.591 173.655 231.591 173.655C231.591 173.655 236.604 173.109 239.377 171.383C242.147 169.651 243.09 167.357 243.09 167.357Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.315 233.074L318.715 230.35L316.52 227.568L312.061 232.268L315.315 233.074Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.061 201.784L263.713 200.394C263.713 200.394 260.532 196.145 260.634 193.392C260.739 190.643 262.324 188.271 262.324 188.271L254.807 188.422C254.807 188.422 251.647 196.356 255.061 201.784Z",
    fill: "#87C6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.064 198.344C204.064 198.344 207.027 195.79 208.876 195.951C210.725 196.111 211.842 196.975 211.842 196.975L209.419 186.005C209.419 186.005 206.92 185.404 204.877 185.733C202.833 186.062 202.257 187.519 202.257 187.519L204.058 198.347L204.064 198.344Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.385 227.671C252.385 227.671 254.572 230.755 258.561 230.878L262.55 231.001L260.536 236.64C260.536 236.64 256.878 237.82 253.766 236.334C250.66 234.845 248.986 232.749 248.986 232.749L252.391 227.668L252.385 227.671Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.906 244.409C229.906 244.409 234.439 239.425 235.284 239.462C236.129 239.5 230.343 234.871 229.352 232.691L228.36 230.511C228.36 230.511 224.324 234.773 224.353 236.265C224.382 237.758 229.9 244.412 229.9 244.412L229.906 244.409Z",
    fill: "url(#paint7_linear_7798_23675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.564 223.364C337.564 223.364 338.682 228.016 339.218 228.289C339.754 228.562 334.632 229.409 333.291 230.412L331.95 231.415C331.95 231.415 330.893 227.384 331.41 226.471C331.927 225.558 337.564 223.364 337.564 223.364Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.584 288.027L338.955 286.668L340.349 293.303C340.349 293.303 338.039 292.919 336.573 293.659L335.112 294.397L333.337 288.656L334.578 288.03L334.584 288.027Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.14 341.015L280.651 336.82L283.435 342.334L277.429 344.373L275.14 341.015Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.797 250.332C284.797 250.332 295.187 250.722 303.425 245.397C311.662 240.072 311.803 238.501 311.803 238.501C311.803 238.501 310.616 237.398 309.038 236.166C307.459 234.934 306.477 233.104 306.477 233.104C306.477 233.104 301.898 237.25 295.639 239.735C289.387 242.218 286.116 242.341 286.116 242.341L284.797 250.332Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87 309.784L293.164 302.959C293.164 302.959 293.157 304.911 291.775 305.703L290.392 306.496L297.709 312.249C297.709 312.249 299.569 309.948 300.873 309.775L300.87 309.784Z",
    fill: "url(#paint8_linear_7798_23675)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_7798_23675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.79 121.867C173.841 123.421 168.514 126.351 167.076 127.694L165.629 129.033C165.629 129.033 160.827 118.502 160.596 117.815L160.366 117.128C160.366 117.128 173.159 113.252 175.49 112.045L177.82 110.839C177.82 110.839 180.045 118.088 180.87 119.912L181.694 121.737C181.694 121.737 179.747 121.566 178.79 121.867Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7599 113.576L68.2595 118.201L77.0225 128.622L80.2604 122.99L73.7599 113.576Z",
    fill: "url(#paint9_linear_7798_23675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.508 239.524C185.956 239.426 187.602 240.203 188.59 240.806C189.583 241.407 189.773 241.971 189.773 241.971C189.773 241.971 190.041 239.541 192.547 237.293C195.053 235.045 196.789 234.933 196.789 234.933C196.789 234.933 191.749 234.757 188.758 236.069C185.769 237.388 184.508 239.524 184.508 239.524Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.409 164.162L118.655 166.372L120.43 169.439L125.515 165.424L122.409 164.162Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.575 203.736L168.814 203.876C168.814 203.876 171.356 208.535 170.861 211.246C170.365 213.951 168.458 216.073 168.458 216.073L175.919 216.997C175.919 216.997 180.179 209.595 177.575 203.736Z",
    fill: "#87C6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.556 214.433C227.556 214.433 224.258 216.538 222.451 216.115C220.644 215.692 219.662 214.678 219.662 214.678L220.494 225.881C220.494 225.881 222.881 226.833 224.95 226.799C227.02 226.765 227.798 225.405 227.798 225.405L227.562 214.431L227.556 214.433Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.919 178.501C183.919 178.501 182.194 175.137 178.264 174.445L174.333 173.754L177.132 168.46C177.132 168.46 180.92 167.814 183.788 169.73C186.65 171.647 188.008 173.961 188.008 173.961L183.912 178.503L183.919 178.501Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.562 165.139C208.562 165.139 203.364 169.425 202.533 169.267C201.702 169.11 206.767 174.517 207.438 176.816L208.108 179.115C208.108 179.115 212.711 175.474 212.895 173.993C213.08 172.511 208.568 165.137 208.568 165.137L208.562 165.139Z",
    fill: "url(#paint10_linear_7798_23675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0006 170.599C99.0006 170.599 98.5593 165.834 98.0676 165.488C97.5758 165.141 102.766 165.034 104.237 164.233L105.707 163.432C105.707 163.432 106.178 167.572 105.536 168.402C104.894 169.232 99.0006 170.599 99.0006 170.599Z",
    fill: "#A5DBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.184 107.023L106.664 107.744L106.232 100.977C106.232 100.977 108.463 101.687 110.02 101.164L111.571 100.643L112.508 106.578L111.19 107.021L111.184 107.023Z",
    fill: "#EFAFAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.586 63.0646L171.533 66.4297L169.565 60.575L175.8 59.4142L177.586 63.0646Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.082 151.439C155.082 151.439 144.854 149.568 135.941 153.662C127.027 157.756 126.663 159.291 126.663 159.291C126.663 159.291 127.681 160.553 129.067 161.997C130.453 163.442 131.163 165.393 131.163 165.393C131.163 165.393 136.288 161.944 142.837 160.378C149.38 158.813 152.635 159.159 152.635 159.159L155.082 151.439Z",
    fill: "#F4C8C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.66 90.3059L154.312 98.1614C154.312 98.1614 154.598 96.23 156.079 95.6435L157.56 95.0569L151.14 88.3175C151.14 88.3175 148.971 90.3292 147.656 90.3141L147.66 90.3059Z",
    fill: "url(#paint11_linear_7798_23675)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7798_23675",
    x1: 334.756,
    y1: 345.303,
    x2: 348.789,
    y2: 348.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7798_23675",
    x1: 226.693,
    y1: 425.37,
    x2: 238.709,
    y2: 428.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7798_23675",
    x1: 328.628,
    y1: 424.992,
    x2: 319.139,
    y2: 422.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7798_23675",
    x1: 60.2512,
    y1: 468.002,
    x2: 46.8748,
    y2: 462.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7798_23675",
    x1: 178.64,
    y1: 404.173,
    x2: 167.186,
    y2: 399.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7798_23675",
    x1: 77.6964,
    y1: 389.996,
    x2: 86.7421,
    y2: 393.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7798_23675",
    x1: 365.366,
    y1: 261.742,
    x2: 372.262,
    y2: 275.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7798_23675",
    x1: 226.558,
    y1: 231.421,
    x2: 232.464,
    y2: 243.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7798_23675",
    x1: 297.706,
    y1: 312.258,
    x2: 293.043,
    y2: 303.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7798_23675",
    x1: 76.9612,
    y1: 128.643,
    x2: 72.0862,
    y2: 114.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7798_23675",
    x1: 210.021,
    y1: 178.473,
    x2: 205.846,
    y2: 166.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7798_23675",
    x1: 151.144,
    y1: 88.3093,
    x2: 154.441,
    y2: 98.1181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8704"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7798_23675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168.858,
    height: 139.116,
    fill: "white",
    transform: "translate(204.441 307.141) rotate(14.3544)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7798_23675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168.858,
    height: 139.116,
    fill: "white",
    transform: "translate(183.78 524.375) rotate(-157.435)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7798_23675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.381,
    height: 146.961,
    fill: "white",
    transform: "translate(305.151 131.547) rotate(63.2125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_7798_23675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.381,
    height: 146.961,
    fill: "white",
    transform: "translate(117.968 266.102) rotate(-108.577)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.9dd5cbb1fb6f6e546880f34da5608ffb.svg";
export { ForwardRef as ReactComponent };